import * as THREE from 'three';
import { BaseModule } from '../base/BaseModule';

export class DeskModule extends BaseModule {
  constructor(
    moduleData,
    moduleType, // "low" | "tall" | "bench"
    sceneManager,
    cabinet = null
  ) {
    super(moduleData, moduleType, sceneManager);

    this.cabinetType = moduleType;
    this.doorType = moduleData.doorType || 'flip'; // flip | slide | swing
    this.hasSeating = moduleData.hasSeating || false; // ghế ngồi đi giày
    this.ventilationType = moduleData.ventilationType || 'standard'; // standard | perforated
    this.material = moduleData.material || 'wood';
    this.color = moduleData.color || '#ffffff';
    this.cabinet = cabinet;
    
    // Constraints cho tủ giày
    this.constraints = this.getConstraints();
  }

  getConstraints() {
    return {
      // Khoảng hở tiêu chuẩn tủ giày
      toeKick: 50, // chân đế thấp hơn tủ áo
      wallGap: 10, // khe hở tường
      
      // Thứ tự ưu tiên
      typePriorities: {
        low: 1,      // tủ thấp
        tall: 2,     // tủ cao
        bench: 3,    // ghế kết hợp
      },

      // Chiều cao danh định (mm)
      typeHeights: {
        low: 900,    // tủ giày thấp (2-3 tầng)
        tall: 1800,  // tủ giày cao (5-6 tầng)
        bench: 450,  // ghế ngồi kết hợp tủ giày
      },

      // Độ sâu tiêu chuẩn
      standardDepth: 350, // mm - vừa giày thể thao/boot
    };
  }

  async load(yPosition) {
    await super.load();

    const calculatedTransform = this.calculateDecorativePosition(yPosition);
    this.setPosition(calculatedTransform.position);
    this.setRotation(calculatedTransform.rotation);

    return this.group;
  }

  scaleModuleWithFormular(mdDimensions = {}, mdOptions = {}) {
    super.scaleModuleWithFormular(mdDimensions, mdOptions);
  }

  calculateDecorativePosition(yPosition) {
    const { position, rotation } = this.findOptimalPosition(yPosition);

    return {
      position: new THREE.Vector3(position.x, yPosition, position.z),
      rotation,
    };
  }

  // Chức năng đặc thù tủ giày
  setHasSeating(hasSeating) {
    this.hasSeating = hasSeating;
    console.log('Shoe cabinet set seating:', hasSeating);
  }

  setVentilationType(type) {
    this.ventilationType = type;
    // TODO: update ventilation panel mesh
  }

  getData() {
    return {
      ...super.getData(),
      doorType: this.doorType,
      hasSeating: this.hasSeating,
      ventilationType: this.ventilationType,
      material: this.material,
      color: this.color,
      cabinetType: this.cabinetType,
    };
  }
}